import React from "react";
import { Button } from "../style";
import { Container, Header, Message, Footer, Backdrop } from "./style";

const Success = (props) => {
  return (
    <Backdrop onClick={props.resetModal}>
      <Container>
        <Header>
          <h2>{props.title}</h2>
        </Header>
        <Message>
          <p>{props.message}</p>
        </Message>
        <Footer>
          <Button onClick={props.resetModal}>Okay</Button>
        </Footer>
      </Container>
    </Backdrop>
  );
};
export default Success;
